import React, { useState } from "react";

import { Divider, Image, Image as SemanticImage } from "semantic-ui-react";

import { selectTranslations } from "../../../config/i18n/slice";

import QRComponentToPrint from "../preview/qrCodeComponent";
import ReactToPrint from "react-to-print";
import { Country, State } from "country-state-city";

import Moment from "react-moment";
import { useHistory } from "react-router-dom";
import { createRef } from "react";

import UserProfilePlaceholder, {
  LetteredAvatarImageUrl,
} from "../../../components/common/userProfilePlaceholder";
import { useSelector } from "react-redux";
import { FileDownloadIcon, Printer } from "../../../../Assets/Icons/svg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import ToolTip from "react-power-tooltip";
import moment from "moment";
import { usePermissionsSimplified } from "../../../../hooks/usePermissionsSimplified";

function General({ data, propertyTypeOptions }) {
  const t = useSelector(selectTranslations);
  const { checkForLinkPermission } = usePermissionsSimplified();
  const [showPrintTooltip, setPrintTooltip] = useState(false);
  const [showDownloadTooltip, setDownloadTooltip] = useState(false);

  const qrRef = createRef();

  const roles = [
    {
      key: 0,
      value: 5,
      text: t.people.add_modal.admin,

      description: t.people.add_modal.admin_description,
    },
    {
      key: 0,
      value: 4,
      text: t.people.add_modal.super_admin,
      description: "",
    },

    {
      key: 2,
      value: 9,
      text: t.people.add_modal.limited_admin,

      description: t.people.add_modal.limited_admin_description,
    },
    {
      key: 1,
      value: 8,
      text: t.people.add_modal.technician,

      description: t.people.add_modal.user_description,
    },

    {
      key: 3,
      value: 3,
      text: t.people.add_modal.viewer,

      description: t.people.add_modal.viewer_description,
    },
    {
      key: 2,
      value: 6,
      text: t.people.add_modal.requester,
      description: t.people.add_modal.requester_desc,
    },
  ];

  const history = useHistory();

  let area = data?.attributes?.areas?.data;
  let areaString = "";
  if (area?.length > 0) {
    areaString = area.map((people) => people.attributes.name).join(", ");
  } else {
    areaString = t.common.na;
  }
  let customers = data.attributes?.customers?.data;
  if (customers?.length > 0) {
    customers = customers.map((people, index) => {
      if (people?.attributes?.logo?.data?.attributes?.url) {
        return checkForLinkPermission("customer") ? (
          <div
            className="d-flex mt-2"
            onClick={() =>
              history.push(`/customers?id=${people?.attributes?.countId}`)
            }
          >
            <Image
              key={index}
              avatar
              title={people.attributes.name + " " + " "}
              src={`${people?.attributes?.logo?.data?.attributes?.url}`}
              // style={
              //   index !== 0
              //     ? { marginLeft: "-6px", width: "34px", height: "34px" }
              //     : { width: "34px", height: "34px" }
              // }
              className={`customer-image ${index !== 0 ? "left" : ""}`}
            />

            <div className="work-order-link mt-1 ml-1" basic>
              {people?.attributes?.name}
            </div>
          </div>
        ) : (
          <div className="d-flex mt-2">
            <Image
              key={index}
              avatar
              title={people.attributes.name + " " + " "}
              src={`${people?.attributes?.logo?.data?.attributes?.url}`}
              // style={
              //   index !== 0
              //     ? { marginLeft: "-6px", width: "34px", height: "34px" }
              //     : { width: "34px", height: "34px" }
              // }
              className={`customer-image ${index !== 0 ? "left" : ""}`}
            />

            <div className=" mt-1 ml-1" basic>
              {people?.attributes?.name}
            </div>
          </div>
        );
      } else {
        return checkForLinkPermission("customer") ? (
          <div
            className="d-flex mt-2"
            onClick={() =>
              history.push(`/customers?id=${people?.attributes?.countId}`)
            }
          >
            <UserProfilePlaceholder
              key={index}
              name={`${
                people?.attributes?.name ? people?.attributes?.name : ""
              } ${""}`}
              width={"34px"}
              height={"34px"}
            />
            <div className="work-order-link mt-1 ml-1" basic>
              {people?.attributes?.name}
            </div>
          </div>
        ) : (
          <div className="d-flex mt-2">
            <UserProfilePlaceholder
              key={index}
              name={`${
                people?.attributes?.name ? people?.attributes?.name : ""
              } ${""}`}
              width={"34px"}
              height={"34px"}
            />
            <div className="ml-1 mt-1" basic>
              {people?.attributes?.name}
            </div>
          </div>
        );
      }
    });
  } else {
    customers = "";
  }

  let vendors = data?.attributes.vendors?.data;

  if (vendors?.length > 0) {
    vendors = vendors.map((people, index) => {
      if (people?.attributes?.logo?.data?.attributes?.url) {
        return checkForLinkPermission("vendor") ? (
          <div
            className="d-flex"
            onClick={() =>
              history.push(`/vendors?id=${people?.attributes?.countId}`)
            }
          >
            <Image
              key={index}
              avatar
              title={people.attributes.name + " " + " "}
              src={`${people?.attributes?.logo?.data?.attributes?.url}`}
              className={`customer-image ${index !== 0 ? "left" : ""}`}
              // style={
              //   index !== 0
              //     ? { marginLeft: "-6px", width: "34px", height: "34px" }
              //     : { width: "34px", height: "34px" }
              // }
            />

            <div className="work-order-link mt-1 ml-1" basic>
              {people?.attributes?.name}
            </div>
          </div>
        ) : (
          <div className="d-flex">
            <Image
              key={index}
              avatar
              title={people.attributes.name + " " + " "}
              src={`${people?.attributes?.logo?.data?.attributes?.url}`}
              className={`customer-image ${index !== 0 ? "left" : ""}`}
              // style={
              //   index !== 0
              //     ? { marginLeft: "-6px", width: "34px", height: "34px" }
              //     : { width: "34px", height: "34px" }
              // }
            />

            <div className=" mt-1 ml-1" basic>
              {people?.attributes?.name}
            </div>
          </div>
        );
      } else {
        return checkForLinkPermission("vendor") ? (
          <div
            className="d-flex mt-2"
            onClick={() =>
              history.push(`/vendors?id=${people?.attributes?.countId}`)
            }
          >
            <UserProfilePlaceholder
              key={index}
              name={`${
                people?.attributes?.name ? people?.attributes?.name : ""
              } ${""}`}
              width={"34px"}
              height={"34px"}
            />
            <div className="work-order-link mt-1 ml-1" basic>
              {people?.attributes?.name}
            </div>
          </div>
        ) : (
          <div className="d-flex mt-2">
            <UserProfilePlaceholder
              key={index}
              name={`${
                people?.attributes?.name ? people?.attributes?.name : ""
              } ${""}`}
              width={"34px"}
              height={"34px"}
            />
            <div className="ml-1 mt-1" basic>
              {people?.attributes?.name}
            </div>
          </div>
        );
      }
    });
  } else {
    vendors = "";
  }

  let customFields = data?.attributes?.customFields;

  if (customFields.length > 0) {
    customFields = customFields.map((el, index) => {
      return (
        <>
          <div className="d-flex align-items-center mt-5">
            <label className="detail-intro-label location-label">
              {t.locations.form.label} {index + 1}
              {":"}
            </label>
            <p className="detail-intro-value">
              {el?.label ? el.label : t.common.na}
            </p>
          </div>

          <div className="d-flex align-items-center mt-5">
            <label className="detail-intro-label location-label">
              {t.locations.form.value} {index + 1}
              {":"}
            </label>
            <p className="detail-intro-value">
              {el?.value ? el.value : t.common.na}
            </p>
          </div>
        </>
      );
    });
  } else {
    customFields = "";
  }

  let peopleName = data?.attributes?.users?.data;
  if (peopleName?.length > 0) {
    peopleName = peopleName.map((person, index) => {
      let filteredRole = roles.filter(
        (role) => person?.attributes?.role?.data?.id == role.value
      );
      let roleText =
        filteredRole && filteredRole[0] ? filteredRole[0].text : "";
      if (roleText)
        return person?.attributes?.profileImage?.data?.attributes?.url ? (
          checkForLinkPermission("people") ? (
            <div className="d-flex mb-5">
              <Image
                avatar
                title={
                  person?.attributes?.firstName +
                  " " +
                  person?.attributes?.lastName
                }
                src={person?.attributes?.profileImage?.data?.attributes?.url}
                height="34px"
                width="34px"
              />

              <div
                onClick={() =>
                  history.push(`/people?id=${person?.attributes?.countId}`)
                }
                className="work-order-link mt-1 ml-1"
              >
                {person?.attributes?.firstName +
                  " " +
                  person?.attributes?.lastName}
              </div>
            </div>
          ) : (
            <div className="d-flex mb-5">
              <Image
                avatar
                title={
                  person?.attributes?.firstName +
                  " " +
                  person?.attributes?.lastName
                }
                src={person?.attributes?.profileImage?.data?.attributes?.url}
                height="34px"
                width="34px"
              />

              <div className="ml-1 mt-1">
                {person?.attributes?.firstName +
                  " " +
                  person?.attributes?.lastName}
              </div>
            </div>
          )
        ) : checkForLinkPermission("people") ? (
          <div className="d-flex mb-5">
            <Image
              height="34px"
              width="34px"
              avatar
              title={
                person?.attributes?.firstName +
                " " +
                person?.attributes?.lastName
              }
              src={LetteredAvatarImageUrl(
                person?.attributes?.firstName +
                  " " +
                  person?.attributes?.lastName
              )}
            />

            <div
              className="work-order-link mt-1"
              onClick={() =>
                history.push(`/people?id=${person?.attributes?.countId}`)
              }
            >
              {person?.attributes?.firstName +
                " " +
                person?.attributes?.lastName}
            </div>
          </div>
        ) : (
          <div className="d-flex mb-5">
            <Image
              height="34px"
              width="34px"
              avatar
              title={
                person?.attributes?.firstName +
                " " +
                person?.attributes?.lastName
              }
              src={LetteredAvatarImageUrl(
                person?.attributes?.firstName +
                  " " +
                  person?.attributes?.lastName
              )}
            />

            <div className=" mt-1">
              {person?.attributes?.firstName +
                " " +
                person?.attributes?.lastName}
            </div>
          </div>
        );
    });
  } else {
    peopleName = "";
  }

  let teamName = data?.attributes?.teams?.data;

  if (teamName?.length > 0) {
    teamName = teamName.map((team, index) =>
      checkForLinkPermission("team") ? (
        <div className="d-flex mb-5">
          <Image
            avatar
            title={team?.attributes.name}
            src={LetteredAvatarImageUrl(team?.attributes.name)}
            height="34px"
            width="34px"
          />

          <div
            onClick={() =>
              history.push(`/teams?id=${team?.attributes?.countId}`)
            }
            className="work-order-link mt-1 ml-1"
          >
            {team?.attributes?.name ? team.attributes.name : t.common.na}
          </div>
        </div>
      ) : (
        <div className="d-flex mb-5">
          <Image
            avatar
            title={team?.attributes.name}
            src={LetteredAvatarImageUrl(team?.attributes.name)}
            height="34px"
            width="34px"
          />

          <div className="mt-1 ml-1">
            {team?.attributes?.name ? team.attributes.name : t.common.na}
          </div>
        </div>
      )
    );
  } else {
    teamName = "";
  }

  return (
    <div className="preview-details-wrapper">
      <div className="data-header">
        {data?.attributes.image?.data?.attributes ? (
          <div
            className={`d-flex justify-content-center align-items-center ${
              data?.attributes?.image?.data?.attributes ? "image-div" : ""
            }`}
            // style={
            //   data?.attributes?.image?.data?.attributes
            //     ? { borderRadius: "8px", background: "lightgrey" }
            //     : {}
            // }
            // className="d-flex justify-content-center align-items-center"
          >
            <SemanticImage
              src={
                data?.attributes.image?.data?.attributes
                  ? data.attributes.image.data.attributes.url
                  : toAbsoluteUrl("/media/default-img.png")
              }
              size="medium"
              className={
                data?.attributes?.image?.data?.attributes
                  ? " data-header-image"
                  : "no-img"
              }
            />
          </div>
        ) : null}
        <div className="header-title mt-5 d-flex justify-content-between align-items-center">
          <div className="header-pill-container">
            <p className="detail-title">{data?.attributes?.name}</p>
          </div>
        </div>
      </div>

      <Divider />

      <div className="detail-intro">
        <div className="d-flex align-items-center mt-6">
          <label className="detail-intro-label location-label">
            {t.locations.table.country}
            {":"}
          </label>
          <p className="detail-intro-value">
            {data?.attributes?.country
              ? Country.getCountryByCode(data?.attributes.country)?.name
              : t.common.na}
          </p>
        </div>

        <div className="d-flex align-items-center mt-5">
          <label className="detail-intro-label location-label">
            {t.locations.table.city}
            {":"}
          </label>
          <p className="detail-intro-value">
            {data?.attributes?.city
              ? State.getStateByCodeAndCountry(
                  data?.attributes?.city,
                  data?.attributes?.country
                )?.name
                ? State.getStateByCodeAndCountry(
                    data?.attributes?.city,
                    data?.attributes?.country
                  )?.name
                : data?.attributes?.cityName
                ? data?.attributes?.cityName
                : t.common.na
              : t.common.na}
          </p>
        </div>

        <div className="d-flex align-items-center mt-5">
          <label className="detail-intro-label location-label">
            {t.locations.table.address}
            {":"}
          </label>
          <p className="detail-intro-value">
            {data?.attributes.address || t.common.na}
          </p>
        </div>
        {!data?.attributes?.isParent ? (
          <div className="d-flex align-items-center mt-5">
            <label className="detail-intro-label location-label">
              {t.assets.form.area}
              {":"}
            </label>
            <p className="detail-intro-value">{areaString}</p>
          </div>
        ) : null}

        <div className="d-flex align-items-center mt-5 mb-5">
          <label className="detail-intro-label location-label">
            {t.locations.form.propertyType}
            {":"}
          </label>
          <p className="detail-intro-value">
            {(() => {
              const locationData = data.attributes?.propertyType;

              if (locationData && Array.isArray(locationData)) {
                const displayText = locationData
                  .map((location) => {
                    const matchedProperty = propertyTypeOptions.find(
                      (prop) => prop.value === location?.property
                    );
                    return matchedProperty
                      ? matchedProperty.text
                      : location?.property;
                  })
                  .join(", ");

                return <span>{displayText ? displayText : t.common.na}</span>;
              } else {
                return <span>{t.common.na}</span>;
              }
            })()}
          </p>
        </div>

        {customFields.length > 0 ? customFields : null}

        <Divider />
        <div className="customer-container d-flex mt-2">
          <label className="workorder-intro-label location-label mt-5">
            {t.locations.table.customer}
            {":"}
          </label>
          <p
            className={`workorder-intro-value ${
              customers.length > 0 ? "mt-3" : "mt-5"
            }`}
          >
            {customers.length > 0 ? customers : t.common.na}
          </p>
        </div>

        <div className="customer-container d-flex mb-5">
          <label className="workorder-intro-label location-label mt-5">
            {t.locations.form.vendors}
            {":"}
          </label>
          <p
            className={`workorder-intro-value ${
              vendors.length > 0 ? "mt-3" : "mt-5"
            }`}
          >
            {vendors.length > 0 ? vendors : t.common.na}
          </p>
        </div>

        <Divider />

        <div className="d-flex mt-5">
          <label className="workorder-intro-label location-label mt-2">
            {t.locations.form.people}
            {":"}
          </label>
          <p className={`workorder-intro-value mt-2`}>
            {peopleName.length > 0 ? peopleName : t.common.na}
          </p>
        </div>

        <div className={`d-flex ${peopleName.length > 0 ? "mt-0" : "mt-5"}`}>
          <label className="workorder-intro-label location-label mt-2">
            {t.locations.form.teams}
            {":"}
          </label>
          <p className={`workorder-intro-value mt-2`}>
            {teamName.length > 0 ? teamName : t.common.na}
          </p>
        </div>

        <Divider />

        <div className="d-flex align-items-start mt-5">
          <label className="workorder-intro-label location-label ">
            {t.assets.filter.qrcode}
            {":"}
          </label>
          <p className="workorder-intro-value set-width">
            <div className="d-flex">
              <div>
                <QRComponentToPrint
                  titleData={t.assets.table.ID}
                  titleName={t.assets.table.name}
                  ref={qrRef}
                  data={{
                    ...data,
                    attributes: {
                      name: data?.attributes?.name,
                      serialNumber: data?.id,
                      count: data?.attributes?.countId,
                    },
                  }}
                  titleString={"LT-"}
                />
              </div>
              <div className="m-3">
                <ReactToPrint
                  trigger={() => (
                    <span
                      className="position-relative c-pointer"
                      onMouseOver={() => setPrintTooltip(true)}
                      onMouseLeave={() => setPrintTooltip(false)}
                    >
                      <Printer />
                      <ToolTip
                        color="#fff"
                        backgroundColor="#172B4D"
                        position="top center"
                        show={showPrintTooltip}
                        textBoxWidth="35px"
                        arrowAlign="center"
                        fontSize="9px"
                        fontWeight="400"
                        fontFamily="Roboto"
                        padding="5px 5px 5px 8px"
                        borderRadius="6px"
                        static
                        moveUp="5px"
                      >
                        <span className="work-order-preview-tooltip">
                          {t.common.print}
                        </span>
                      </ToolTip>
                    </span>
                  )}
                  content={() => {
                    return qrRef.current;
                  }}
                />
                <span
                  className="position-relative ml-2 mr-2 c-pointer"
                  onMouseOver={() => setDownloadTooltip(true)}
                  onMouseLeave={() => setDownloadTooltip(false)}
                  onClick={() => {
                    qrRef.current.exposeDownloadFunction();
                  }}
                >
                  <FileDownloadIcon />
                  <ToolTip
                    color="#fff"
                    backgroundColor="#172B4D"
                    position="top center"
                    show={showDownloadTooltip}
                    textBoxWidth="92px"
                    arrowAlign="center"
                    fontSize="9px"
                    fontWeight="400"
                    fontFamily="Roboto"
                    padding="5px 5px 5px 8px"
                    borderRadius="6px"
                    static
                    moveUp="5px"
                  >
                    <span className="work-order-preview-tooltip">
                      {t.common.download_QR}
                    </span>
                  </ToolTip>
                </span>
              </div>
            </div>
          </p>
        </div>

        <Divider />
        <div className="d-flex align-items-center mt-5">
          <label className="workorder-intro-label location-label grey">
            {t.workOrders.table.createdByUser}
            {":"}
          </label>
          <p className="workorder-intro-value grey">
            {data?.attributes?.createdByUser?.data?.attributes?.firstName &&
            data?.attributes?.createdByUser?.data?.attributes?.lastName
              ? data?.attributes?.createdByUser?.data?.attributes?.firstName +
                " " +
                data?.attributes?.createdByUser?.data?.attributes?.lastName
              : t.common.na}
            {", "}
            <Moment format="DD/MM/YYYY LT" date={data?.attributes?.createdAt} />
          </p>
        </div>

        <div className="d-flex align-items-center mt-3">
          <label className="workorder-intro-label location-label grey">
            {t.common.update_by}
            {":"}
          </label>
          <p className="workorder-intro-value grey">
            {data?.attributes?.updatedByUser?.data
              ? data?.attributes?.updatedByUser?.data?.attributes?.firstName +
                " " +
                data?.attributes?.updatedByUser?.data?.attributes?.lastName +
                ", " +
                moment(data?.attributes?.updatedAt).format("DD/MM/YYYY LT")
              : t.common.na}
          </p>
        </div>
      </div>
    </div>
  );
}

export default General;
